import Axios from "../config/axios-v1-config";
import { errorHandler } from "../utils/errorHandler";

// Comunicaciones masivas por el número de WhatsApp del operador
// (microservice-packages, `/packages/alerts/whatsapp/broadcasts`). Ninguna función tostea:
// el panel muestra el error una sola vez, con el texto del backend cuando lo hay.

const handle = (err, fallbackMessage, context) =>
  errorHandler.handleApiError(err, { showNotification: false, fallbackMessage, context });

/**
 * Crea la comunicación. Responde 202 con
 * `{ broadcastId, status, replayed, totalRecipients, excludedCount, excluded, estimate }`.
 * Reintentar con la MISMA `idempotencyKey` devuelve la misma campaña.
 */
export const createWhatsappBroadcast = async (payload) => {
  try {
    const response = await Axios.post("packages/alerts/whatsapp/broadcasts", payload);
    return { success: true, data: response.data, error: null };
  } catch (err) {
    return {
      success: false,
      data: null,
      error: handle(err, "No se pudo crear la comunicación. Inténtalo nuevamente.", "WhatsApp broadcast create"),
    };
  }
};

export const getWhatsappBroadcasts = async ({ page = 1, limit = 10 } = {}) => {
  try {
    const response = await Axios.get("packages/alerts/whatsapp/broadcasts", { params: { page, limit } });
    return { success: true, data: response.data, error: null };
  } catch (err) {
    return {
      success: false,
      data: null,
      error: handle(err, "No se pudo cargar el historial de comunicaciones.", "WhatsApp broadcast list"),
    };
  }
};

export const getWhatsappBroadcast = async (id) => {
  try {
    const response = await Axios.get(`packages/alerts/whatsapp/broadcasts/${encodeURIComponent(id)}`);
    return { success: true, data: response.data, error: null };
  } catch (err) {
    return {
      success: false,
      data: null,
      error: handle(err, "No se pudo cargar el progreso de la comunicación.", "WhatsApp broadcast detail"),
    };
  }
};

export const cancelWhatsappBroadcast = async (id) => {
  try {
    const response = await Axios.post(`packages/alerts/whatsapp/broadcasts/${encodeURIComponent(id)}/cancel`);
    return { success: true, data: response.data, error: null };
  } catch (err) {
    return {
      success: false,
      data: null,
      error: handle(err, "No se pudo cancelar la comunicación.", "WhatsApp broadcast cancel"),
    };
  }
};
